import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { useIsMobile } from "./hooks/use-mobile";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import AppPage from "./pages/AppPage";
import AcceleratorPage from "./pages/AcceleratorPage";
import FutureJobsPage from "./pages/FutureJobsPage";
import AdminApp from "./pages/AdminApp";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/app" element={<AppPage />} />
      <Route path="/accelerator" element={<AcceleratorPage />} />
      <Route path="/future-jobs" element={<FutureJobsPage />} />
      <Route path="/admin" element={<AdminApp />} />
    </Routes>
  );
}

function ThemedToaster() {
  const { isLight } = useTheme();
  const isMobile = useIsMobile();
  return <Toaster theme={isLight ? "light" : "dark"} position={isMobile ? "bottom-center" : "top-right"} richColors />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <ThemedToaster />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
